/**
 * Shared visitor-state matching helpers used by any component that reveals
 * content based on the visitor's IPStack-resolved state (e.g. the geo-targeted
 * media duo and the location pop up).
 */

export function normalizeState(value) {
	if (!value) return '';
	return value.toString().trim().toLowerCase();
}

/**
 * @param {string[]} options wide-net match strings (term name/slug variants)
 * @param {string} normalizedState already-normalized visitor state
 * @return {boolean}
 */
export function matchesState(options, normalizedState) {
	if (!Array.isArray(options) || !normalizedState) return false;
	return options.some(option => normalizeState(option) === normalizedState);
}

export function parseStateOptions(rawOptions) {
	if (!rawOptions) return [];

	try {
		const parsed = JSON.parse(rawOptions);
		return Array.isArray(parsed) ? parsed : [];
	} catch (err) {
		return [];
	}
}
